"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectedBar = exports.NodeWrapper = exports.Container = exports.Wrapper = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = __importDefault(require("../styled-components"));
exports.Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
`;
exports.Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: min(600px, 67vh);
  padding-bottom: ${({ theme }) => theme.gutter};
`;
exports.NodeWrapper = styled_components_1.default.div `
  user-select: none;
  position: relative;
  box-shadow: 0 2px 0 0 #0000;
  display: flex;
  background: ${(props) => (props.selected ? "#7dc2ff44" : "#fff1")};
  padding: 5px;
  margin-bottom: 5px;
  border-radius: ${(props) => props.theme.radius};
  text-align: left;
  word-break: break-word;
  cursor: ${(props) => props.noPointer || props.deSelected ? "initial" : "pointer"};
  width: 100%;
  height: 30px;
  overflow: hidden;
  padding-left: 10px;
  opacity: ${(props) => (props.deSelected ? 0.4 : 1)};
`;
exports.SelectedBar = styled_components_1.default.div `
  background: ${(props) => (props.selected ? props.theme.highlight : "#fff1")};
  width: 5px;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 1;
`;
//# sourceMappingURL=style.js.map